import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GHANGE_ACTIVE_HOTEL: (state, action) => ({
			...state,
			activeId: action.payload.activeId === state.activeId ? -1 : action.payload.activeId,
		}),
	},
	{
		activeId: -1,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/justExplore.js